import { useSendSignEntry } from "../mutate-hooks/use-send-sign-entry";

export const useSendSignEntryModal = (
  sectionOneId: string,
  search?: string,
) => {
  const { handleSend: sendToSign } = useSendSignEntry(sectionOneId, search);

  const handleSend = ({
    sectionOneListId,
    itemNoVersionId,
  }: {
    sectionOneListId: string;
    itemNoVersionId: string;
  }) => {
    sendToSign({
      sectionOneListId,
      itemNoVersionId,
    });
  };

  return { handleSend };
};

